import Vue from 'vue'
import Vuex from 'vuex'
import TestModule from '@/store/TestModule.js'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    TestModule
  },
  state: {
    val: 'aiueo'
  },
  getters: {
    getVal(state){ return state.val + ' OK'; }
  },
  mutations: {

  },
  actions: {

  }
})
